// MIDLERTIDIG testside — slettes efter verifikation.
import { useEffect, useState } from 'react'
import ImageCropper from '../utillityComponents/ImageCropper'

export default function CropSandbox() {
  const [rawFile, setRawFile] = useState(null)
  const [result, setResult] = useState(null)
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    if (!result) return undefined
    const url = URL.createObjectURL(result)
    setPreview(url)
    return () => URL.revokeObjectURL(url)
  }, [result])

  return (
    <div className="p-8 max-w-lg">
      <input
        id="sandbox-input"
        type="file"
        accept="image/*"
        onChange={(e) => { setRawFile(e.target.files[0]); setResult(null) }}
      />
      {rawFile && !result &&
        <ImageCropper file={rawFile} onConfirm={setResult} onCancel={() => setRawFile(null)} />
      }
      {preview &&
        <div id="sandbox-result" data-size={result.size} data-name={result.name} data-type={result.type}>
          <img src={preview} alt="resultat" className="w-60 mt-4 border" />
        </div>
      }
    </div>
  )
}
